<template>
  <div class="bg-primary">
    <a-row>
      <a-col :span="24" :xxl="{span:8, offset:8}" :xl="{span:8, offset:8}" :lg="{span:12, offset:6}"
             :md="{span:16, offset:4}">
        <a-card title="学会网站平台——团队会员注册"
                :bordered="false"
                style="width: 100%; margin:4rem 0"
                :headStyle="{textAlign:'center', fontWeight:'bolder',fontSize:'1.5rem'}">
          <a-form-model
            ref="ruleForm"
            :model="form"
            :rules="rules"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
          >
            <a-form-model-item ref="name" label="公司全称" prop="name" help="与营业执照上名称一致">
              <a-input
                v-model="form.name"
                @change="error.name=''"
                @blur="() => {$refs.name.onFieldBlur();}"/>
              <span class="text-danger" v-if="error.name">{{ error.name }}</span>
            </a-form-model-item>
            <a-form-model-item label="营业执照副本" required>
              <a-button style="margin-right: 1rem" type="primary" @click.stop="uploadImg">选择文件</a-button>
              <img style="height:3rem" src="" :src="licence" @click.stop="uploadImg">
              <a-input id="licence"
                       accept="image/*"
                       type="file"
                       @change="handleFile"
                       style="display:none"
              />
              <span class="text-danger" v-if="error.business_license">{{ error.business_license }}</span>
            </a-form-model-item>
            <a-form-model-item ref="USCC" label="组织机构编码" prop="USCC" help="统一信用号码/公司税号">
              <a-input
                v-model="form.USCC"
                @change="error.USCC=''"
                @blur="() => { $refs.USCC.onFieldBlur(); }"
              />
              <span class="text-danger" v-if="error.USCC">{{ error.USCC }}</span>
            </a-form-model-item>
            <a-form-model-item ref="legal_name" label="法人姓名" prop="legal_name">
              <a-input
                v-model="form.legal_name"
                @change="error.legal_name=''"
                @blur="() => { $refs.legal_name.onFieldBlur(); }"
              />
              <span class="text-danger" v-if="error.legal_name">{{ error.legal_name }}</span>
            </a-form-model-item>
            <a-form-model-item ref="legal_phone" label="法人手机号" prop="legal_phone">
              <a-input v-model="form.legal_phone"/>
            </a-form-model-item>
            <a-form-model-item label="团体类型" prop="enterprise_type">
              <a-select v-model="form.enterprise_type">
                <template v-for="item in items">
                  <a-select-option :value="item.value">
                    {{ item.text }}
                  </a-select-option>
                </template>

              </a-select>
            </a-form-model-item>
            <a-form-model-item label="业务范围" prop="business">
              <a-input v-model="form.business"/>
            </a-form-model-item>
            <a-form-model-item ref="address" label="地址" prop="address">
              <a-input
                v-model="form.address"
                @change="error.address=''"
                @blur="() => { $refs.address.onFieldBlur(); }"
              />
              <span class="text-danger" v-if="error.address">{{ error.address }}</span>
            </a-form-model-item>
            <a-form-model-item label="邮编">

              <a-input v-model="form.postcode"></a-input>
            </a-form-model-item>
            <a-form-model-item label="邮箱">
              <a-input v-model="form.email"></a-input>
            </a-form-model-item>
            <a-form-model-item label="座机">

              <a-input-group compact>
                <a-input style="width: 30%" v-model="form.areacode"/>
                <a-input style="width: 70%" v-model="form.telephone"/>
              </a-input-group>

            </a-form-model-item>
            <a-form-model-item ref="linkman" label="联系人姓名" prop="linkman">
              <a-input
                v-model="form.linkman"
                @change="error.linkman=''"
                @blur="() => { $refs.linkman.onFieldBlur(); }"
              />
              <span class="text-danger" v-if="error.linkman">{{ error.linkman }}</span>
            </a-form-model-item>
            <a-form-model-item ref="linkphone" label="联系人手机号" prop="linkphone" help="可用于登录系统，请务必填写">
              <a-input
                v-model="form.linkphone"
                @change="error.linkphone=''"
                @blur="() => { $refs.linkphone.onFieldBlur(); }"
              />
              <span class="text-danger" v-if="error.linkphone">{{ error.linkphone }}</span>
            </a-form-model-item>
            <a-form-model-item ref="linkposition" label="联系人职务" prop="linkposition">
              <a-input
                v-model="form.linkposition"/>
            </a-form-model-item>
            <a-form-model-item ref="password" label="密码" prop="password" autocomplete="off">
              <a-input-password v-model="form.password" placeholder="请输入密码"/>
              <span class="text-danger" v-if="error.password">{{ error.password }}</span>
            </a-form-model-item>
            <a-form-model-item ref="password2" label="重复密码" required prop="password2" autocomplete="off">
              <a-input-password v-model="form.password2" placeholder="请再次输入密码"/>
              <span class="text-danger" v-if="error.password2">{{ error.password2 }}</span>
            </a-form-model-item>

            <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }" style="text-align: center">
              <a-button type="primary" @click="onSubmit">
                注册
              </a-button>
              <a-button style="margin-left: 10px;" @click="resetForm">
                重置
              </a-button>
            </a-form-model-item>

            <div style="margin: 24px">
              <router-link :to="{name:'login'}" class="text-primary">已有账号，马上登录</router-link>
              <router-link :to="{name:'register'}" class="text-primary float-right">个人会员注册</router-link>
            </div>
          </a-form-model>
        </a-card>
      </a-col>
    </a-row>


  </div>

</template>
<script>
import {createUserOrganization, createUserPerson} from "../../api/api";
import cookie from "../../../static/js/cookie";

export default {
  name: "RegisterCompany",
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('密码不能为空'));
      } else {
        if (this.form.password !== '') {
          callback();
        }
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {

      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.password) {
        callback(new Error("两次输入的密码不相同!"));
      } else {
        callback();
      }
    };

    return {
      labelCol: {span: 6},
      wrapperCol: {span: 14},
      items1: [{message: 'Foo'},
        {message: 'Bar'}],
      items: [
        {value: "1", text: "私营企业"},
        {value: "2", text: "国有企业"},
        {value: "3", text: "事业单位"},
        {value: "4", text: "国有控股企业"},
        {value: "5", text: "国家行政机关"},
        {value: "6", text: "个体工商户"},
        {value: "7", text: "合伙企业"},
        {value: "8", text: "联营企业"},
        {value: "9", text: "股份制企业"},
        {value: "10", text: "外资企业"},
        {value: "11", text: "合资企业"},
        {value: "12", text: "其它"}
      ],
      licence: '',

      form: {
        name: '',
        USCC: '',
        business_license: '',
        legal_name: '',
        legal_phone: '',
        enterprise_type: '1',
        business: '',
        linkman: '',
        linkphone: '',
        linkposition: '',
        address: '',
        postcode: '',
        areacode: '',
        telephone: '',
        email: '',
        password: '',
        password2: '',
        part: 'O',

      },
      error: {
        name: '',
        USCC: '',
        legal_name: '',
        business_license: '',
        linkman: '',
        linkphone: '',
        address: ''
      },
      rules: {
        name: [
          {required: true, message: '团体名称不能为空', trigger: 'blur'},
          {min: 2, max: 20, message: '团体名称位2-20个字符', trigger: 'blur'},
        ],
        business_license: [
          {required: true, message: '必须上传营业执照副本', trigger: 'blur'},

        ],
        legal_name: [
          {required: true, message: '法人代表名字不能为空', trigger: 'blur'},
          {min: 2, max: 20, message: '法人代表名字长度不对', trigger: 'blur'},
        ],
        linkman: [
          {required: true, message: '联系人名字不能为空', trigger: 'blur'},
          {min: 2, max: 20, message: '联系人名字长度不对', trigger: 'blur'},
        ],
        address: [
          {required: true, message: '地址不能为空', trigger: 'blur'},
          {min: 2, message: '地址长度不对', trigger: 'blur'},
        ],
        linkphone: [
          {required: true, message: '联系人手机号不能为空', trigger: 'blur'},
          {min: 11, max: 11, message: '联系人手机号错误', trigger: 'blur'},
        ],
        USCC: [{required: true, message: '组织机构编码不能为空', trigger: 'blur'}],
        password: [{validator: validatePass, trigger: 'change'}],
        password2: [{validator: validatePass2, trigger: 'change'}],

      },
    };
  },
  computed:{
    params() {
      let data = new FormData()

      data.append('name', this.form.name)
      data.append('USCC', this.form.USCC)
      data.append('business_license', this.business_license)
      data.append('legal_name', this.form.legal_name)
      data.append('legal_phone', this.form.legal_phone)
      data.append('enterprise_type', this.form.enterprise_type)
      data.append('business', this.form.business)
      data.append('linkman', this.form.linkman)
      data.append('linkphone', this.form.linkphone)
      data.append('linkposition', this.form.linkposition)
      data.append('address', this.form.address)
      data.append('postcode', this.form.postcode)
      data.append('areacode', this.form.areacode)
      data.append('telephone', this.form.telephone)
      data.append('email', this.form.email)
      data.append('password', this.form.password)
      data.append('password2', this.form.password2)
      data.append('part', this.form.part)
      return data
    }

  },
  methods: {
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          var that = this;
          createUserOrganization(
            that.params
          )
            .then((response) => {

              cookie.setCookie('name', response.data.name, 7);
              cookie.setCookie('token', response.data.token, 7)
              cookie.setCookie('part', response.data.part, 7)
              cookie.setCookie('uid', response.data.uid, 7)
              cookie.setCookie('mid', response.data.mid, 7)


              // 更新store数据
              that.$store.dispatch('setInfo');
              that.$store.dispatch('setOrg');


              if (this.$store.getters.url) {
                that.$router.replace({path: this.$store.getters.url})
              } else {
                //跳转到我的简历
                that.$router.push({name: 'scf'})
              }


            })
            .catch(function (error) {

              if ("name" in error) {
                that.error.name = error.name[0];
              }
              if ("password" in error) {
                that.error.password = error.password[0];
              }

              if ("phone" in error) {
                that.error.phone = error.phone[0];
              }
              if ("birthday" in error) {
                that.error.birthday = error.birthday[0];
              }
              if ("organization" in error) {
                that.error.organization = error.organization[0];
              }

              if ("position" in error) {
                that.error.position = error.position[0];
              }

            });
        } else {
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
    uploadImg: function () {
      document.getElementById("licence").click()
      document.getElementById("licence").parentElement.setAttribute('required', false)
    },
    //预览图片
    handleFile: function (e) {
      let $target = e.target
      let file = $target.files[0]
      this.business_license = file
      let reader = new FileReader()
      reader.onload = (data) => {
        let res = data.target

        this.licence = res.result

      }
      reader.readAsDataURL(file)
    },

  },
};
</script>
<style scoped>
a:hover {
  color: rebeccapurple;
}
</style>



// WEBPACK FOOTER //
// src/components/sign/RegisterCompany.vue